import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getVersion } from '../api/version';

export const versionKeys = createQueryKeys('version', {
  currentVersion: {
    queryKey: null,
    queryFn: (options) => getVersion(options),
  },
});
